/**
 * SearchResult → SearchHelper 복귀 시 전달할 데이터
 *
 * globalThis를 사용하여 모듈 번들링과 무관하게
 * JS 런타임 전체에서 동일한 값을 공유합니다.
 *
 * instanceId 기반 Map으로 관리하여 여러 SearchHelper-SearchResult 쌍이
 * 동시에 존재해도 정확한 대상에게만 데이터를 전달합니다.
 */
const SEARCH_RETURN_KEY = '__SEARCH_RETURN_DATA__';

type SearchReturnData = { query: string };

const g = globalThis as unknown as Record<string, unknown>;

const getMap = (): Map<string, SearchReturnData> => {
  if (!(g[SEARCH_RETURN_KEY] instanceof Map)) {
    g[SEARCH_RETURN_KEY] = new Map<string, SearchReturnData>();
  }
  return g[SEARCH_RETURN_KEY] as Map<string, SearchReturnData>;
};

export const setSearchReturnData = (
  targetInstanceId: string,
  data: SearchReturnData,
) => {
  getMap().set(targetInstanceId, data);
};

export const consumeSearchReturnData = (
  instanceId: string,
): SearchReturnData | null => {
  const map = getMap();
  const data = map.get(instanceId) ?? null;
  map.delete(instanceId);
  return data;
};